<mat-card class="component-card">
  <mat-card-title>
    <h1 class="pb-3">Hourly Forecast</h1>
  </mat-card-title>

  <mat-card-content>
    @if (!loading) {
      <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="date">
          <th mat-header-cell *matHeaderCellDef>Date</th>
          <td mat-cell *matCellDef="let forecast">
            {{ forecast.date | date: 'EEEE dd MMM' }}
          </td>
        </ng-container>

        <ng-container matColumnDef="time">
          <th mat-header-cell *matHeaderCellDef>Time</th>
          <td mat-cell *matCellDef="let forecast">{{ forecast.time | date: 'HH' }}h</td>
        </ng-container>

        <ng-container matColumnDef="weatherTypes">
          <th mat-header-cell *matHeaderCellDef>Weather</th>
          <td mat-cell *matCellDef="let forecast">
            <img
              class="weather-icon"
              [src]="'../../../../assets/weather/' + forecast.weatherTypes.next1Hour + '.svg'"
              [alt]="forecast.weatherTypes.next1Hour" />
          </td>
        </ng-container>

        <ng-container matColumnDef="temperature">
          <th mat-header-cell *matHeaderCellDef>Temperature</th>
          <td mat-cell *matCellDef="let forecast">
            <span [ngClass]="forecast.temperature.value < 0 ? 'negative-temp' : 'positive-temp'">
              {{ forecast.temperature.value }}°C
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="feelsLike">
          <th mat-header-cell *matHeaderCellDef>Feels Like</th>
          <td mat-cell *matCellDef="let forecast">
            <span [ngClass]="forecast.feelsLike < 0 ? 'negative-temp' : 'positive-temp'">
              {{ forecast.feelsLike }}°C
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="precipitation">
          <th mat-header-cell *matHeaderCellDef>Precipitation</th>
          <td mat-cell *matCellDef="let forecast">
            @if (forecast.precipitation.max > 0) {
              {{ forecast.precipitation.min }} - {{ forecast.precipitation.max }} mm
            } @else {
              -
            }
          </td>
        </ng-container>

        <ng-container matColumnDef="wind">
          <th mat-header-cell *matHeaderCellDef>Wind</th>
          <td mat-cell *matCellDef="let forecast">
            {{ forecast.wind.speed }} ({{ forecast.wind.gust }}) m/s
            {{ forecast.wind.directionArrow }}
          </td>
        </ng-container>

        <ng-container matColumnDef="cloudCover">
          <th mat-header-cell *matHeaderCellDef>Cloud Cover</th>
          <td mat-cell *matCellDef="let forecast">{{ forecast.cloudCover.value }}%</td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    }
  </mat-card-content>

  @if (loading) {
    <mat-progress-bar mode="query" />
  }
</mat-card>
